<template>
    <TxProductViewport>
        <template v-slot="{ dimm }">
            <TxProductViewportScaler
                    :layout="mapLayout"
                    :dimm="$root.env !== 'renderer' ? dimm : false"
            >
                <component :is="componentName">
                    <TxProductAspectRatio
                            v-if="loaded"
                            :layout="mapLayout"
                            :size="size"
                            :aspect-ratios="aspectRatios"
                    >
                        <slot></slot>
                    </TxProductAspectRatio>
                </component>
            </TxProductViewportScaler>
        </template>
    </TxProductViewport>
</template>

<script>
    import ProductAspectRatios from '../config/ProductAspectRatios'
    import TxTemplateBlock from './TxTemplateBlock'

    export default {
        name: "TxRendererProduct",
        components: {TxTemplateBlock},
        props: {
            mapLayout: {
                type: String,
            },
            componentName: {
                type: String,
                default: 'TxTemplateBlock'
            },
            size: {},
            aspectRatios: {
                default() {
                    return ProductAspectRatios
                }
            }
        },
        data() {
            return {
                loaded: false
            }
        },
        mounted() {
            this.$nextTick(()=>{
                this.loaded = true
            })
        }
    }
</script>

<style scoped>

</style>